function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.72909 2.08334H8.24992C9.71867 2.08334 10.8958 3.28126 10.8958 4.75105V8.30209C10.8958 9.78126 9.71867 10.9688 8.24992 10.9688H4.72909C3.27075 10.9688 2.08325 9.78126 2.08325 8.30209V4.75105C2.08325 3.28126 3.27075 2.08334 4.72909 2.08334ZM4.72909 14.0309H8.24992C9.71867 14.0309 10.8958 15.2195 10.8958 16.6987V20.2497C10.8958 21.7184 9.71867 22.9164 8.24992 22.9164H4.72909C3.27075 22.9164 2.08325 21.7184 2.08325 20.2497V16.6987C2.08325 15.2195 3.27075 14.0309 4.72909 14.0309ZM20.2709 2.08334H16.75C15.2813 2.08334 14.1042 3.28126 14.1042 4.75105V8.30209C14.1042 9.78126 15.2813 10.9688 16.75 10.9688H20.2709C21.7292 10.9688 22.9167 9.78126 22.9167 8.30209V4.75105C22.9167 3.28126 21.7292 2.08334 20.2709 2.08334ZM16.75 14.0309H20.2709C21.7292 14.0309 22.9167 15.2195 22.9167 16.6987V20.2497C22.9167 21.7184 21.7292 22.9164 20.2709 22.9164H16.75C15.2813 22.9164 14.1042 21.7184 14.1042 20.2497V16.6987C14.1042 15.2195 15.2813 14.0309 16.75 14.0309Z",
  fill: "white"
});
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.c47e1355ea6f0f2f9a4772f603299bef.svg";
export { ForwardRef as ReactComponent };